import { Typography } from 'antd';
import type { ReactNode } from 'react';

export function PageHeader({ title, subtitle, extra }: { title: string; subtitle?: string; extra?: ReactNode }) {
  return <div className="page-header"><div><Typography.Title level={2} className="page-title">{title}</Typography.Title>{subtitle && <div className="page-subtitle">{subtitle}</div>}</div>{extra}</div>;
}
